import { CONTACT } from "@/lib/contact";
import { scrollToSection } from "@/lib/lenis";

export const Footer = () => (
  <footer className="bg-[#050A1C] py-12">
    <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      <button onClick={() => scrollToSection("home")} data-testid="footer-logo-btn" className="flex items-center gap-2 font-serif text-xl text-white">
        <img src="/favicon.png" alt="Grow High Accounting logo" className="w-8 h-8 rounded-full" />
        Grow High <span className="text-[#C5A059]">Accounting</span>
      </button>
      <p className="text-slate-500 text-sm">
        &copy; {new Date().getFullYear()} Grow High Accounting, Chennai. All rights reserved.
      </p>
      <div className="flex gap-6 text-base text-slate-400">
        <a href={CONTACT.phoneHref} data-testid="footer-phone-link" className="hover:text-[#C5A059] transition-colors">
          {CONTACT.phoneDisplay}
        </a>
        <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="hover:text-[#C5A059] transition-colors">
          {CONTACT.email}
        </a>
      </div>
    </div>
  </footer>
);
